import React from 'react';
import { styled } from '@linaria/react';
import { Announcer } from 'clad-ui';
import { CHOTOT_LOGO } from '~/constants';
type Props = {
  children?: JSX.Element | (JSX.Element | boolean)[];
  desktopMinHeight?: string;
};
const BoxWithLogo = (props: Props) => {
  const {
    children,
    desktopMinHeight
  } = props;
  return <Box desktopMinHeight={desktopMinHeight}>
      <div className="logo">
        <img src={CHOTOT_LOGO} alt="Chotot Logo" />
      </div>
      {children}
    </Box>;
};
BoxWithLogo.Title = /*#__PURE__*/styled('h3')({
  name: "BoxWithLogo0",
  class: "b13ldopu",
  propsAsIs: false
});
BoxWithLogo.Note = /*#__PURE__*/styled('p')({
  name: "BoxWithLogo1",
  class: "b1ijgv5p",
  propsAsIs: false
});
BoxWithLogo.ErrorArea = ({
  open,
  message,
  mb,
  mt
}: {
  open?: boolean;
  message?: string;
  mb?: string;
  mt?: string;
}) => {
  return <ErrorWrapper mb={mb} mt={mt}>
      <Announcer open={open} type="error">
        {message}
      </Announcer>
    </ErrorWrapper>;
};
const _exp4 = /*#__PURE__*/() => ({
  mt
}) => mt || '0';
const _exp5 = /*#__PURE__*/() => ({
  mb
}) => mb || '20px';
const ErrorWrapper = /*#__PURE__*/styled('div')({
  name: "ErrorWrapper",
  class: "e1nrpfz9",
  propsAsIs: false,
  vars: {
    "e1nrpfz9-0": [_exp4()],
    "e1nrpfz9-1": [_exp5()]
  }
});
const _exp7 = /*#__PURE__*/() => ({
  desktopMinHeight
}) => desktopMinHeight || 'unset';
const Box = /*#__PURE__*/styled('div')({
  name: "Box",
  class: "b4hnkwj",
  propsAsIs: false,
  vars: {
    "b4hnkwj-0": [_exp7()]
  }
});
export default BoxWithLogo;

require("./BoxWithLogo.linaria.module.css!=!../../../node_modules/.pnpm/@linaria+webpack5-loader@4.1.17_webpack@5.83.1/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./BoxWithLogo.tsx");